module.exports = __webpack_public_path__ + "static/media/entertainment-icon.02a3f44e.svg";